import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TestlistService } from '@app-services/test/testlist.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { navigateBetweenProjects } from 'src/app/helpers/functions';
import { dashboardRoute } from '@app-constants/app.constants';

@Component({
  selector: 'app-account-confirm-dialog',
  templateUrl: './account-confirm-dialog.component.html',
  styleUrls: ['./account-confirm-dialog.component.css']
})
export class AccountConfirmDialogComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
               private dialog: MatDialog,
               private dialogRef: MatDialogRef<AccountConfirmDialogComponent>,
               public router: Router,private testListService: TestlistService,
               private gaService: GAnalyticsService) { }

  ngOnInit(): void {
    this.gaService.sendEvent(
      'account_confirmed', 
      'confirmed',
      'account_confirmed', 
      'reached',  
    );
    this.dialogRef.disableClose = this.data?.disableClose ? this.data.disableClose: true;
  }
  paperClicked(test: any) {
    this.dialogRef.close(test);
    return;
  }

  onClose() {
    this.dialogRef.close();
  }

  navigateToDashboard(): void {
    this.gaService.sendEvent(
      'account_confirmed_to_dashboard', 
      'confirmed', 
      'account_confirmed_to_dashboard', 
      'skip_to_dashboard',  
    );
    this.dialogRef.close();
    if(this.data?.actionData?.redirection){
      //this.router.navigate([this.data?.actionData?.redirection]);
      navigateBetweenProjects(this.router, this.data?.actionData?.redirection);
    } else {
      navigateBetweenProjects(this.router, dashboardRoute);
    }
  }


  accountSetup() : void {
    this.gaService.sendEvent(
      'account_confirmed_to_onboarding', 
      'confirmed',
      'account_confirmed_to_onboarding', 
      'start_onboarding',  
    );
    this.dialogRef.close();
    if(this.data?.actionData?.redirection){
    
    this.router.navigate(['setup-account'],{ queryParams: { returnUrl: this.data?.actionData?.redirection}});
    } else {
      this.router.navigate(['setup-account']);  
    }
  }
}
